import { createStore, compose, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootSaga from '../sagas';

let _store = {};

// used to retrieve store outside of the component scope.
export const getStore = () => _store;

// google optimize middleware
const googleOptmizeMiddleware = () => next => action => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ event: 'optimize.activate' });

  return next(action);
};

/**
 * Responsible for creating store,
 * also applying enhanced middlewares onto stores.
 *
 * @param {function} rootReducer
 * @param {object} preloadedState
 * @param {object} context
 */
export default function configureStore(
  rootReducer,
  preloadedState,
  context = {}
) {
  const sagaMiddleware = createSagaMiddleware();
  const composeEnhancers =
    (process.env.NODE_ENV === 'local' &&
      typeof window === 'object' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const store = createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(applyMiddleware(googleOptmizeMiddleware, sagaMiddleware))
  );

  sagaMiddleware.run(rootSaga, context);

  if (module.hot) {
    module.hot.accept('../redux/reducers', () => {
      const nextRootReducer = require('../redux/reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextRootReducer);
    });
  }

  // be able to run saga on the serverside to acheive server side rendering.
  store.runSagas = sagaMiddleware.run;

  _store = store;

  return store;
}



// WEBPACK FOOTER //
// ./app/store/configureStore.js